module.exports = __webpack_public_path__ + "Sailec-Bold.6bf3648fcce3a14786ca.eot";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Bold/Sailec-Bold.eot
// module id = ../../../../../src/assets/fonts/Sailec-Bold/Sailec-Bold.eot
// module chunks = styles